import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpContext } from '@angular/common/http';
import { of } from 'rxjs';
import { HttpContextConfig } from '../models/http-context-config';
import { CONFIG } from '../interceptors/loader.interceptor';

const sbiURL = `${environment.api}/sbi`;

@Injectable({
  providedIn: 'root'
})
export class SbiService {
  constructor(private http: HttpClient) {}

  getSbiForReviewWidget(data: any) {
    let config = new HttpContextConfig();
    config.noSpinner = true;
    const context = new HttpContext().set(CONFIG, config);

    return of({ result: null });
  }

  getSbiById(id: number) {
    return this.http.get<any>(`${sbiURL}/getSbiById/${id}`);
  }

  getSbi(data: any) {
    return this.http.post<any>(`${sbiURL}/index`, data);
  }

  getMyUsers() {
    return this.http.get<any>(`${sbiURL}/getMyUsers`);
  }

  getPmOrAdminUsers() {
    return this.http.get<any>(`${sbiURL}/getPmOrAdminUsers`);
  }

  getAllProjects() {
    return this.http.get<any>(`${sbiURL}/getAllProjects`);
  }

  addSbi(sbi: any) {
    return this.http.post<any>(`${sbiURL}/store`, sbi);
  }

  updateAlias(data: any, sbiId: number) {
    return of({ result: data });
  }

  updateReviewNote(data: any, reviewId: number) {
    return of({ result: data });
  }

  updateReviewSoftSkills(data: any, reviewId: number) {
    return of({ result: data });
  }

  getSoftSkills() {
    return of([]);
  }

  destroy(id: number) {
    return this.http.delete<any>(`${sbiURL}/destroy/${id}`);
  }

  updateSbi(sbi: any, id: number) {
    return this.http.put<any>(`${sbiURL}/update/${id}`, sbi);
  }

  addOrUpdateComment(sbiId: number, data: any) {
    return this.http.post<any>(`${sbiURL}/comment/${sbiId}`, data);
  }
}
